import React from 'react';
import { dehydrate, QueryClient } from '@tanstack/react-query';
import { ArrowLeftIcon } from 'icons';
import { GetStaticProps } from 'next';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { getLanguage, globalConst } from 'modules/global';
import { getSubjects, Main, natCerfConst } from 'modules/national-certificate';

import { NextHead } from 'components';

const Index = () => {
  const t = useTranslations();

  return (
    <>
      <NextHead title={t('meta.national_certificate.title')} description={t('meta.national_certificate.description')} />

      <div className="max-w-screen mx-auto my-9 min-h-screen p-3 lg:p-0">
        <Link href={globalConst.pageNames.BLOCK_TEST}>
          <div className="m-4 inline-flex cursor-pointer items-center justify-start gap-2 font-semibold sm:m-0">
            <ArrowLeftIcon /> {t('common.ortga_qaytish')}
          </div>
        </Link>
        <Main />
      </div>
    </>
  );
};

export default Index;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const queryClient = new QueryClient();

  await Promise.allSettled([
    queryClient.prefetchQuery({
      queryKey: [globalConst.queryKeys.GET_LANGUAGE],
      queryFn: getLanguage
    }),
    queryClient.prefetchQuery({
      queryKey: [natCerfConst.queryKeys.NATIONAL_CERTIFICATE_SUBJECTS],
      queryFn: getSubjects
    })
  ]);

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
      messages: (await import(`../../messages/${locale}.json`)).default
    },
    revalidate: 604800
  };
};
